import React, { Component } from 'react'
import {Link} from 'react-router-dom'
class EventBoxs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataEvents: [
                {
                    id: 1,
                    srcimg: 'images/imagebox/features/YEARS_EXP_.png',
                    title: 'YEARS OF EXPERIENCE',
                    description: '', 
                    link:'/aboutoverview'
                },
                {
                    id: 2,
                    srcimg: 'images/imagebox/features/EXPERTISE_.png',
                    title: 'EXPERTISE',
                    description: '',
                    link:'/aboutoverview'
                },
                {
                    id: 3,
                    srcimg: 'images/imagebox/features/CLIENT_FOCUSED_.png',
                    title: 'CLIENT FOCUSED',
                    description: '',
                    link:'/aboutoverview'
                },
            ]
        }
    }
    
    render() {
        return (
            <div className="row">
                {
                    this.state.dataEvents.map(data => (
                        <div className="col-md-4" key={data.id}>
                            <div className="imagebox-item">
                                <div className="imagebox style1">
                                    <div className="imagebox-image">
                                        <img src={data.srcimg} alt="financial" />
                                    </div>
                                    {/* <!-- /.imagebox-image --> */}
                                    
                                    <div className="imagebox-title">
                                        <h3><Link to={data.link} onClick={() => {window.location.href=`${data.link}`}} title="">{data.title}</Link></h3>
                                    </div>
                                    {/* <!-- /.iamgebox-title --> */}
                                    <div className="imagebox-content">
                                        <div className="imagebox-desc">{data.description}</div>
                                        <div className="imagebox-button">
                                            <Link to={data.link} onClick={() => {window.location.href=`${data.link}`}} title="">read more</Link>
                                        </div>
                                    </div>
                                    {/* <!-- /.imagebox-content --> */}
                                </div>
                                {/* <!-- /.imagebox --> */}
                            </div>
                            {/* <!-- /.imagebox-item --> */}
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default EventBoxs;